module.exports = __webpack_public_path__ + "static/media/govt-baking-course-bg.bb28a8c2.webp";